/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });

    console.log(InstantSearchResultItemProduct.prototype);
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  // # Start Partner Request
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
		switch (tempType) {
			case InstantSearchResultItemProduct.tempType.IMAGE:
				return `
					<div class="{{class.searchSuggestion}}-left">
						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
					</div>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE:
				return `
					<p class="{{class.searchSuggestion}}-product-price js-inc-vat">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
            <span class="vatText">({{incVatText}})</span> 
					</p>
          <p class="{{class.searchSuggestion}}-product-price js-ex-vat">
						<span class="{{class.searchSuggestion}}-product-regular-price">{{exVatPrice}}</span>
            <span class="vatText">({{exVatText}})</span> 
					</p>
				`.trim();
			case InstantSearchResultItemProduct.tempType.PRICE_SALE:
				return `
          {{vatSavingsPrice}}{{exVatSavingsPrice}}
					<p class="{{class.searchSuggestion}}-product-price js-inc-vat">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
						<s class="compare-price">{{compareAtPrice}}</s>
            <span class="vatText">({{incVatText}})</span> 
					</p>
          <p class="{{class.searchSuggestion}}-product-price js-ex-vat">
            <span class="{{class.searchSuggestion}}-product-sale-price">{{exVatPrice}}</span>
						<s class="compare-price">{{exVatComparePrice}}</s>
            <span class="vatText">({{exVatText}})</span>
					</p>
				`.trim();
			default:
				return `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
                {{itemStockIndicator}}
								<p class="{{class.searchSuggestion}}-product-title">{{escapedTitle}}</p>
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim();
		}
	}

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {

    // MB: Getting the product variant
    const productVariant = this.data.variants;

		if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
        
        if (this.imageUrl.includes("image_200x")) {
          this.imageUrl = this.imageUrl.replace("image_200x", "image_400x");
        }
        
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
        
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
      
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

      // MB: Getting tax percentages
      var vatPercentage = document.querySelector('.js-vat-percentage').value;
      
      // MB: Calculate tax percentage
      var tax_percentage_string = '1.' + vatPercentage;
      var tax_percentage = tax_percentage_string || 0;

      // MB: Getting price including VAT
      var vatPrice = this.data.price_min;
      var vatComparedPrice = this.data.compare_at_price_min;

      //MB: Calculating the excluding VAT price
      var exVatPrice = vatPrice / tax_percentage;
      var exVatComparePrice = vatComparedPrice / tax_percentage;

      // MB: Calculating the savings if theres a compared price with VAT
      var vatSavingsPrice = vatComparedPrice - vatPrice;
      var vatSavingsPill = '<span class="js-inc-vat savings-label">Save ' + Utils.formatMoney(vatSavingsPrice) + '</span>';

      // MB: Calculating the savings if theres a compared price excluding VAT
      var exVatSavingsPrice = exVatComparePrice - exVatPrice;
      var exVatSavingsPill = '<span class="js-ex-vat savings-label">Save ' + Utils.formatMoney(exVatSavingsPrice) + '</span>';
      
      var preOrderMessage = this.data.metafields[0];

      if (preOrderMessage && preOrderMessage.value !== null) {
        var stockIconClass = 'bg-red';
        var stockText = window.stock.outOfStock;
      } else {
        var stockIconClass = 'bg-green';
        var stockText = window.stock.inStock;
      }
      
      // MB: Creating function for stock indicator
      function buildStockIndicator() {

        var html = '';

        html += '<div class="availability relative mb-2.5 flex items-center text-sm max-w-fit text-primary leading-[18px]">';
          html += '<span class="relative w-2.5 h-2.5 rounded-full mr-2 ' + stockIconClass + '"></span>';
          html += stockText;
        html += '</div>';

        return html;
      }

      return this.getTemplate()
      .replace(/{{id}}/g, this.id)
      .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
      .replace(/{{url}}/g, '/products/' + this.data.handle)
      .replace(/{{newTabAttribute}}/g, newTabAttr)
      .replace(/{{itemProductImage}}/g, imageHTML)
      .replace(/{{title}}/g, productTitle)
      .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
      .replace(/{{itemStockIndicator}}/g, buildStockIndicator())
      .replace(/{{itemProductSku}}/g, skuHTML)
      .replace(/{{itemProductVendor}}/g, vendorHTML)
      .replace(/{{itemProductPrice}}/, priceHTML)
      .replace(/{{exVatPrice}}/, Utils.formatMoney(exVatPrice))
      .replace(/{{exVatComparePrice}}/, Utils.formatMoney(exVatComparePrice))
      .replace(/{{exVatText}}/, exVat)
      .replace(/{{incVatText}}/, incVat)
      .replace(/{{vatSavingsPrice}}/, vatSavingsPill)
      .replace(/{{exVatSavingsPrice}}/, exVatSavingsPill)
      .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
      .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
      .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
      
		} else {
			return '';
		}
	}
  // # End Partner Request
  

})();